import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { paths } from '@app/constants';
import { Namespace } from '@data';
import { CategoryType } from '@data/sdk/match';
import { AntdTag } from '@ui/components';

const typeMap = {
  [CategoryType.Tag]: {
    color: 'warning',
  },
  [CategoryType.IcdCode]: {
    color: 'geekblue',
  },
  [CategoryType.Starter]: {
    color: 'success',
  },
  [CategoryType.MergedQuestion]: {
    color: 'blue',
  },
};

type QuestionTagProps = {
  name: string;
  type: CategoryType;
};

export const QuestionTag = ({ type, name }: QuestionTagProps) => {
  const { color } = typeMap[type];

  return (
    <AntdTag color={color} className="text-sm m-0 h-6 leading-6">
      {name}
    </AntdTag>
  );
};

type MoreTagsProps = {
  count: number;
  id: string;
};

export const MoreTags = ({ id, count }: MoreTagsProps) => {
  const { t } = useTranslation([Namespace.ADMIN]);

  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    navigate(`${id}/${paths.questions_library.classification.root}`, { state: { from: location } });
  };

  return (
    <AntdTag color="blue" onClick={handleClick} className="text-sm m-0 h-6 leading-6">
      {t('questions_library.question.show_more', { count })}
    </AntdTag>
  );
};
